import { State } from '@energy-retailer/constants';
import { z } from 'zod';

export const nmiAddressSchema = z.object({
  id: z.string().optional(),
  full: z.string().optional(),
  postcode: z.string(),
  state: z.nativeEnum(State),
  suburb: z.string(),
});

export type NmiAddressSchema = z.infer<typeof nmiAddressSchema>;
